import React, { createContext, useContext, useEffect, useState } from 'react';
import { publicAPI } from '../api';

const SiteSettingsContext = createContext({});

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    publicAPI.getSettings().then(r => {
      const raw = r.data.data || {};
      // Flatten: { key: { value, type } } => { key: value }
      const flat = {};
      Object.entries(raw).forEach(([key, val]) => {
        flat[key] = typeof val === 'object' && val.value !== undefined ? val.value : val;
      });
      setSettings(flat);
    }).catch(console.error)
    .finally(() => setLoaded(true));
  }, []);

  return (
    <SiteSettingsContext.Provider value={{ settings, loaded }}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export const useSiteSettings = () => useContext(SiteSettingsContext);

export default SiteSettingsContext;